<template>
  <main>
    <menus class="menus"/>
    <section class="address">
      <header>
        <h3>我的账户管理 <span>(您已创建 <b>{{ list.length }}</b> 个提现账户最多可创建10个)</span></h3>
        <el-button type="warning" v-show="list.length < 10" @click="showDialog('add')">添加账户</el-button>
      </header>
      <el-table :data="list">
        <el-table-column type="index" align="center" label="序号"></el-table-column>
        <el-table-column prop="addressee" label="姓名" width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column label="开户银行" width="150">
          <template slot-scope="s">
            <span>{{s.row | getAddressDesc}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="银行账号" ></el-table-column>
        <el-table-column width="240" label="操作">
          <template slot-scope="s">
            <el-button size="mini" type="warning" @click="showDialog('edit', s.row)">编辑</el-button>
            <el-popconfirm 
              class="delete"
              confirmButtonText='是的'
              cancelButtonText='不用了'
              icon="el-icon-info"
              iconColor="red"
              title="确定删除吗？"
              @confirm="deleteAddress(s.row.id)">
              <el-button slot="reference" size="mini" type="danger">删除</el-button>
            </el-popconfirm>
            <el-button size="mini" type="info" v-show="s.row.is_default !== 1" @click="setDefault(s.row)">设为默认</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <el-dialog :title="dialog.type === 'add' ? '添加地址' : '编辑地址'" :visible.sync="dialog.show" width="750px">
      <ul>
        <li>
          <span>姓名：</span>
          <el-input v-model="dialog.addressee" size="small"></el-input>
        </li>
        <li>
          <span>身份证号码：</span>
          <el-input maxlength="11" v-model="dialog.phone" size="small"></el-input>
        </li><li>
          <span>开户银行：</span>
          <el-input maxlength="11" v-model="dialog.city" size="small"></el-input>
        </li>
        <!-- <li>
          <span>选择地址：</span>
          <el-cascader
            v-model="dialog.city"
            :options="chinaCity"
            :props="cityProps"
            filterable
            size="small"></el-cascader>
        </li> -->
        <li>
          <span>街道地址：</span>
          <el-input v-model="dialog.address" size="small"></el-input>
        </li>
        <li>
          <span>银行账号：</span>
          <el-input v-model="dialog.company_names" size="small" ></el-input>
          
        </li>
        <li>
          <span>身份证正面：</span>
          <el-input  v-model="dialog.company_name" size="small" accept="image/*"  type="file" id="uploadIMG"  @click="btnUploadFile(event)"></el-input>
          <img src="" alt="" id="showIMG">
        </li>
        <!-- <li>
          <span>身份证反面：</span>
          <el-input  v-model="dialog.company_name" size="small" accept="image/*"  type="file" id="uploadIMGs"  onchange="btnUploadFiles(event)"></el-input>
          <img src="" alt="" id="showIMGs">
        </li> -->
        <li>
          <span>默认地址：</span>
          <el-switch v-model="dialog.is_default"></el-switch>
        </li>
      </ul>
      <el-button type="warning" @click="addAddress">{{ dialog.type === 'add' ? '添加' : '修改' }}</el-button>
    </el-dialog>

  </main>
</template>

<script>
import Menus from '@components/menu';
import $strategy from '@assets/js/strategy';
import $user from '@api/user';
export default {
  components: {
    Menus
  },
  data () {
    return {
      list: [],
      dialog: {
        type: null,
        show: false,
        id: null,
        addressee: null, // 收件人
        address: null, // 地址
        phone: null, // 手机号
        city: null, // 市
        company_name: null, // 公司名称
        is_default: false // 默认地址
      },
      chinaCity: [], // 城市列表
      cityProps: {
        expandTrigger: 'hover',
        label: 'name',
        value: 'name'
      }
    }
  },
  filters: {
    getAddressDesc (item) {
      const { province, city, district, address } = item;
      return `${ province+city+district+address }`
    }
  },
  created () {
    this.chinaCity = window.china_citys;
    this.getAddress();
  },
  methods: {
    setDefault (item) {
      const data = {...item, is_default: 1};
      $user.updateAddress(data).then(res => {
        this.updateList(res.OK, '默认地址修改成功！');
      })
    },
    deleteAddress (id) {
      $user.deleteAddress(id).then(res => {
        this.updateList(res.OK, '删除地址成功！');
      })
    },
    getAddress () {
      $user.getAddress().then(list => {
        this.list = list;
      });
    },
    addAddress () {
      const { type, id, address, addressee, phone, city: selectedCity, company_name, is_default } = this.dialog;
      if ( $strategy.check(addressee, 'isEmpty') ) {
        this.$message.warning('收件人有误！');
        return false;
      }
      if ( $strategy.check(phone, 'isMobile') === false ) {
        this.$message.warning('手机号码有误！');
        return false;
      }
      if ( !!selectedCity === false || selectedCity.length === 0 ) {
        this.$message.warning('请选择地址！');
        return false;
      }
      if ( !!address === false || address.length === 0 ) {
        this.$message.warning('请输入街道地址！');
        return false;
      }
      const [province, city, district] = selectedCity;
      const data = {
        address, addressee, phone, company_name, 
        province, city, district, id,
        is_default: is_default ? 1 : 0,
      };
      return
      const fnName = type === 'add' ? 'addAddress' : 'updateAddress';
      $user[fnName](data).then(res => {
        const { OK } = res;
        this.updateList(OK, `${type === 'add' ? '添加' : '修改'}地址成功！`);
        this.clearAddData();
      });
      
    },
    clearAddData (show = false, type = null) {
      this.dialog = {
        show,
        type,
        id: null,
        addressee: null, // 收件人
        address: null, // 地址
        phone: null, // 手机号
        city: null, // 市
        company_name: null, // 公司名称
        is_default: false // 默认地址
      }
    },
    updateList (list, msg) {
      this.list = list;
      !!msg && this.$message.success(msg);
    },
    showDialog (type, data) {
      switch (type) {
        case 'add': {
          this.clearAddData(true, type);
          break;
        }
        case 'edit': {
          const { 
            id, addressee, address, phone, 
            company_name, is_default, province, 
            city, district } = data;
          let dialog = {
            addressee, address, phone,
            company_name, id,
            show: true,
            type: 'edit',
            city: [province, city, district], // 市
            is_default: (is_default === 1 ? true : false),
          }
          this.dialog = dialog;
          break;
        }
      }
    },
    btnUploadFile(e,type){
        //获取图片
        var files = e.target.files;
        var file = files[0];
        // 接受 jpeg, jpg, png 类型的图片
        if (!/\/(?:jpeg|jpg|png)/i.test(file.type)){
            return;
        }
        var reader = new FileReader();
        reader.onload = function() { 
            var result = this.result;  //图片base64字符串
            $("#showIMG").attr("src",result);  //展示图片
        };
        reader.readAsDataURL(file);    //Base64
    },
    // btnUploadFiles(e,type){
    //     //获取图片
    //     var files = e.target.files;
    //     var file = files[0];
    //     // 接受 jpeg, jpg, png 类型的图片
    //     if (!/\/(?:jpeg|jpg|png)/i.test(file.type)){
    //         return;
    //     }
    //     var reader = new FileReader();
    //     reader.onload = function() { 
    //         var result = this.result;  //图片base64字符串
    //         $("#showIMGs").attr("src",result);  //展示图片
    //     };
    //     reader.readAsDataURL(file);    //Base64
    // },
 
// function (baseIMG){
//    $.ajax({
//        url: url,  //上传的地址
//        type: "post",
//        data: {"imgsrc": baseIMG},
//        success: function(data){
        
//        }
//    })
// }
  }
}
</script>

<style scoped src="./list.css"></style>